module.exports = __webpack_public_path__ + "static/img/btn3.c2e24816.png";